import { get, post } from '@/utils/request.js'
import { h5CustomerApi } from '../base/urlConfig.js'


/**
 * @func 用户登录
 */
export function CustomerLoginService(data) {
    var url = h5CustomerApi.CustomerLogin
    return post(url, data, true)
}


/**
 * @func 用户注册
 */
export function CustomerRegisterService(data) {
    var url = h5CustomerApi.CustomerRegister
    return post(url, data, true)
}


/**
 * @func 获取用户信息
 */
export function FetchCustomerInfoService(token) {
    var url = h5CustomerApi.FetchUserInfo
    let params = { token: token }
    return post(url, params, true)
}

/**
 * @func 忘记密码
 */
export function forgotPasswordService(email) {
    var url = h5CustomerApi.ForgotPassword
    let params = { email: email }
    return post(url, params, true)
}

/**
 * @func 重置密码
 */
export function resetPasswordService(token, password) {
    var url = h5CustomerApi.ResetPassword + token + "/"
    let data = { password: password }
    return post(url, data, true)
}

/**
 * @func 发送客户购物车日志
 * @param {*} params
 * @returns
 */
export function logCartService(params) {
    var url = h5CustomerApi.LogCart
    return post(url, params, true)
}
